
import { TranslationRecord } from '../../types';

export const about: TranslationRecord = {
  // About page
  aboutTitle: 'Σχετικά με εμάς',
  aboutSubtitle: 'Μάθετε περισσότερα για το Loena Luxury Suites',
  ourStory: 'Η Ιστορία μας',
  ourMission: 'Η Αποστολή μας',
  ourVision: 'Το Όραμά μας',
  
  // Brand story
  brandStoryTitle: 'Η Ιστορία του Loena',
  brandStorySubtitle: 'Από την αρχή μέχρι σήμερα',
  
  // Values
  ourValues: 'Οι Αξίες μας',
  excellence: 'Αριστεία',
  excellence_description: 'Επιδιώκουμε την τελειότητα σε κάθε λεπτομέρεια',
  hospitality: 'Φιλοξενία',
  hospitality_description: 'Προσφέρουμε ζεστή και προσωπική εξυπηρέτηση',
  authenticity: 'Αυθεντικότητα',
  authenticity_description: 'Παρέχουμε γνήσια εμπειρία της Θεσσαλονίκης',
  
  // Team
  meetOurTeam: 'Γνωρίστε την Ομάδα μας',
  teamDescription: 'Άνθρωποι που νοιάζονται για την εμπειρία σας',
  
  // FAQ
  faqTitle: 'Συχνές Ερωτήσεις',
  faqSubtitle: 'Όλα όσα χρειάζεται να γνωρίζετε',
  
  // Common FAQ questions
  checkInTime: 'Τι ώρα είναι το check-in;',
  checkInAnswer: 'Το check-in είναι στις 15:00. Πρώιμο check-in διατίθεται κατόπιν συνεννόησης.',
  
  checkOutTime: 'Τι ώρα είναι το check-out;',
  checkOutAnswer: 'Το check-out είναι στις 11:00. Όψιμο check-out διατίθεται κατόπιν διαθεσιμότητας.',
  
  parkingAvailable: 'Διατίθεται πάρκινγκ;',
  parkingAnswer: 'Ασφαλές πάρκινγκ διατίθεται κοντά στο κατάλυμα με επιπλέον χρέωση.',
  
  wifiPassword: 'Ποιος είναι ο κωδικός Wi-Fi;',
  wifiAnswer: 'Ο κωδικός Wi-Fi παρέχεται κατά το check-in. Προσφέρουμε υψηλής ταχύτητας internet 100 Mbps.',
  
  petsAllowed: 'Επιτρέπονται τα κατοικίδια;',
  petsAnswer: 'Δυστυχώς δεν επιτρέπονται κατοικίδια στις σουίτες μας.',
  
  smokingPolicy: 'Ποια είναι η πολιτική για το κάπνισμα;',
  smokingAnswer: 'Το κάπνισμα απαγορεύεται σε όλους τους εσωτερικούς χώρους. Διατίθεται μπαλκόνι για καπνιστές.',
};
